import { useState, useEffect } from 'react';
import { AdminService } from '../../../../core/services/AdminService';
import { DataBeanProperties } from '../../../../core/services/model/server-response.interface';

interface Props {
    idSelector: number;
    onChange: any;
    _MenuType: number;
    _idAplication: number;
}

export const SelectorAplicationMenu = ({ idSelector, onChange, _MenuType, _idAplication }: Props) => {

    const service = new AdminService();
    const [lista, setLista] = useState([]);
    const [id, setID] = useState(null);

    useEffect(()=>{
        if(idSelector)
        {
            if(idSelector != id){
                setID(idSelector);
            }
        }
    },[idSelector])

    useEffect(() => {
        getLista();
    }, [_MenuType, _idAplication])

    useEffect(() => {
        onChange(id);
    }, [id])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(id);
    }

    const getLista = () => {
        service.getApplicationTypeCatalogByMenuTypeandIdAplication(_MenuType, _idAplication).subscribe((resp: any) => {
           //console.log("Application", resp);
            if (resp.DataBeanProperties.ObjectValue) {
                setLista(resp.DataBeanProperties.ObjectValue);
            }
        });
    };

    return (
        <>
            <label className='mb-2'>Aplicación / Menú</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={null}>...</option>
                {lista &&
                    lista.map((item: any) => {
                        return (
                            <>
                                <option key={item.DataBeanProperties.IDApplicationType} value={item.DataBeanProperties.IDApplicationType} >
                                    {item.DataBeanProperties.Name} {item.DataBeanProperties.MenuValueName ? `- ${item.DataBeanProperties.MenuValueName}` : ''}
                                    </option>
                            </>)
                    })
                }
            </select>
        </>
    )
}
